export const Period = Object.freeze({
  LastMonth: 0,
  All: 1
});
